import styled from "styled-components";

const ItemIngredientsPanelStyled = styled.div`

`;

export default ItemIngredientsPanelStyled;